import './styles/DesktopOnly.scss';

import { MobileOff } from '@mui/icons-material';
import { Grid, Paper } from '@mui/material';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';
import { useLayout } from 'utils/hooks/useLayout';

export function DesktopOnly() {
  const { t } = useTranslation();
  const { setDesktopOnly } = useLayout();

  useEffect(() => {
    return () => {
      setDesktopOnly(false);
    };
  }, [setDesktopOnly]);

  return (
    <Grid container component={Paper} className="desktop-only">
      <Grid container justifyContent="center" className="desktop-only__icon">
        <MobileOff />
      </Grid>
      <Grid container className="desktop-only__message">
        <Grid item xs>
          {t(translations.layout.desktopOnly())}
        </Grid>
      </Grid>
    </Grid>
  );
}
